import {WalletBalance} from "@alpha-nft/marketplace-models";
import {marketplaceServerUrl} from "../lib/utils";

export async function fetchSolWalletBalance(pubkey: string): Promise<WalletBalance> {
  return (await fetch(`${marketplaceServerUrl()}/sol/wallets/${pubkey}/balance?commitment=confirmed`)).json();
}